import { render, staticRenderFns } from "./ScratchResult.vue?vue&type=template&id=e5d4b614&scoped=true"
import script from "./ScratchResult.vue?vue&type=script&lang=js"
export * from "./ScratchResult.vue?vue&type=script&lang=js"
import style0 from "./style.scss?vue&type=style&index=0&id=e5d4b614&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d4b614",
  null
  
)

export default component.exports